import { faCircleInfo } from '@fortawesome/pro-light-svg-icons/faCircleInfo'
import { faFolder } from '@fortawesome/pro-light-svg-icons/faFolder'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import Icon from '@space-core/components/icon'
import { useScrollOnRender } from '@space-shell/remotes/preview/hooks'
import { useParentInfoStore } from '@space-shell/remotes/preview/store/parentInfo'

import { useTranslation } from 'react-i18next'

import { NUMBER_OF_CARDS } from './sectionEmptyStateConstants'
import {
  Container,
  Showcase,
  Highlight,
  EmptyStateHighLight,
  Card,
  Category,
  EmptyStateContent
} from './sectionEmptyStateStyles'

type SectionEmptyStateProps = {
  enableScroll?: boolean
}

const SectionEmptyState = ({ enableScroll = false }: SectionEmptyStateProps) => {
  const { t } = useTranslation()
  const { showSectionHighlight } = useParentInfoStore()
  const sectionRef = useScrollOnRender({ enabled: enableScroll })

  return (
    <div ref={sectionRef} id='section-empty-state' className='_position-relative'>
      <Container className='_position-relative'>
        {showSectionHighlight && (
          <>
            <EmptyStateHighLight className='_position-absolute _w-full' />
            <Highlight className='_position-absolute _text-white _px-2 _bg-blue _rounded-bottom _d-flex _align-items-center _justify-content-center'>
              <span>{t('preview.highlights.section')}</span>
            </Highlight>

            <EmptyStateContent className='_position-absolute _text-gray-900 _bg-primary _text-center _px-4 _py-3'>
              <Icon className='_mr-4' icon={faCircleInfo} size='lg' />
              <span className='_text-1 _font-weight-bold _m-0'>
                {t(`preview.sections.empty_state.active_products`)}
              </span>
            </EmptyStateContent>
          </>
        )}

        <Category />

        <Showcase className='_overflow-hidden'>
          {Array.from({ length: NUMBER_OF_CARDS }).map((_, index) => (
            <Card
              key={`card-${index}`}
              className='_w-full _h-full _rounded-lg _d-flex _align-items-center _justify-content-center'>
              <FontAwesomeIcon icon={faFolder} size='2x' />
            </Card>
          ))}
        </Showcase>
      </Container>

      <Container>
        <Category />

        <Showcase className='_overflow-hidden'>
          {Array.from({ length: NUMBER_OF_CARDS }).map((_, index) => (
            <Card
              key={`card-${index}`}
              className='_w-full _h-full _rounded-lg _d-flex _align-items-center _justify-content-center'>
              <FontAwesomeIcon icon={faFolder} size='2x' />
            </Card>
          ))}
        </Showcase>
      </Container>
    </div>
  )
}

export default SectionEmptyState
